"use client";
import React, { useState } from "react";
import { Recommendation } from "./recommendation";

export default function ComplementaryStylesRecommendation({
  handles,
  key,
  loading,
  s,
  c,
  complementaryStyles,
  productPositions,
}: {
  handles: Record<string, any>[];
  key: string;
  loading: boolean;
  s: any;
  c: any;
  complementaryStyles: Record<string, any>;
  productPositions: Record<string, any>;
}) {
  const [activeHandle, setActiveHandle] = useState(
    handles.length > 0 ? handles[0] : null,
  );

  return (
    <div className="">
      <div className="hp-flex hp-border-b swimlane hp-px-4">
        {handles.length > 0
          ? handles.map((el) => {
              return (
                <>
                  <button
                    className={`hp-py-2 hp-text-sm hp-font-semibold hp-uppercase ${
                      activeHandle?.handle === el.handle
                        ? "hp-border-b-2 hp-border-[#181818] hp-text-[#181818]"
                        : "hp-border-b hp-text-[#A7A7A7]"
                    }`}
                    onClick={() => setActiveHandle(el)}
                  >
                    {el?.handle?.split("-").join(" ")}
                  </button>
                </>
              );
            })
          : null}
      </div>
      {handles.length > 0
        ? handles.map(
            (el) =>
              activeHandle?.handle == el.handle && (
                <Recommendation
                  type={"complete-the-look"}
                  similarLst={s}
                  complementartLst={c}
                  key={key}
                  loading={loading}
                  currentProductHandle={el?.handle}
                  complementaryStyles={complementaryStyles[el?.handle]}
                  currentProductPosition={productPositions[el?.handle]}
                  hideTypeSelectionTab={true}
                />
              ),
          )
        : null}
    </div>
  );
}
